import React, { useState, useEffect, useRef } from "react";
import { useHistory } from 'react-router-dom';
import styled from "styled-components";
import moment from 'moment';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import FetchModule from "../../Model/Share/Network/FetchModule";

import CustomInput from "../Component/CustomInput";
import CountryCodeSelectBox from "../../Component/ClassManageComponent/CountryCodeSelectBox";
import ProfileInput from "../Component/ProfileInput";
import TextAreaInput from "../Component/TextAreaInput";
import CalenderInput from "../Component/CalendarInput";
import DiscountAmountInput from "../../Component/MemberComponent/DiscountAmountInput";
import PaymentOptionCustomInput from "../Component/PaymentOptionCustomInput";

import OptionSelectBox from "../Model/OptionSelectBox";
import GenderSelectBox from "../Model/GenderSelectBox";
import PaymentOptionSettingSelectBox from "../Model/PaymentOptionSettingSelectBox";
import AddPaymentOptionModal from "../Model/AddPaymentOptionModal";
import LinkoPayPaymentModal from "../Model/LinkoPayPaymentModal";
import OnSitePaymentModal from "../Model/OnSitePaymentModal";
import RegistrationCompleteModal from "../../Model/Individual/MemberModel/RegistrationCompleteModal";

import WhiteTrashIcon from '../../image/WhiteTrashIcon.png';
import ClickLockerImagePath from '../../image/ClickLocker.png';
import { ReactComponent as PlusSvg } from '../../image/Plus.svg';

export default function MemberRegistrationPage(props) {

  const history = useHistory();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t, isEng } = useLanguage();

  const countryCodeSelectBoxRef = useRef(null);

  const DefaultPaymentOption = [{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }];

  // status //
  const [isLoading, setIsLoading] = useState(false);
  const [isFindUserId, setIsFindUserId] = useState(false);
  const [phoneErrorMsg, setPhoneErrorMsg] = useState('');
  const [isClickedAddPaymentOption, setIsClickedAddPaymentOption] = useState(false);
  // status //

  // value //
  const [isUseLinkoPay, setIsUseLinkoPay] = useState(false);
  const [isViewPaymentModal, setIsViewPaymentModal] = useState(false);

  const [isInProgress, setIsInProgress] = useState(false);
  const [isViewCompleteModal, setIsViewCompleteModal] = useState(false);
  const [registeredMemberId, setRegisteredMemberId] = useState(null);

  const [selectedCountry, setSelectedCountry] = useState({ countryCode: '+82', flagUrl: 'https://picture.link-zone.org/flags/kr.svg', countryNameKR: '대한민국', countryNameEN: 'South Korea' });
  const [noHavePhone, setNoHavePhone] = useState(false);
  const [phone, setPhone] = useState('');
  const [userId, setUserId] = useState('');
  const [name, setName] = useState('');
  const [profile, setProfile] = useState('');
  const [gender, setGender] = useState('female');
  const [birth, setBirth] = useState('');
  const [memberDetail, setMemberDetail] = useState('');

  const [memberships, setMemberships] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categorizedMemberships, setCategorizedMemberships] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({ id: 0, name: t('memberRegistration.select') });
  const [selectedMembership, setSelectedMembership] = useState({ id: 0, name: t('memberRegistration.select') });
  const [paymentOptions, setPaymentOptions] = useState([{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }]);
  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);
  const [selectedLockerPaymentOptions, setSelectedLockerPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);

  const [startDate, setStartDate] = useState(moment().format('YYYY.MM.DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY.MM.DD'));
  const [approvalDate, setApprovalDate] = useState(moment().format('YYYY.MM.DD'));
  const [totalMax, setTotalMax] = useState(-1);
  const [discount, setDiscount] = useState('0');
  const [notReceived, setNotReceived] = useState('0');
  const [totalPoint, setTotalPoint] = useState(0);

  const [isUseLocker, setIsUseLocker] = useState(false);
  const [availableLockers, setAvailableLockers] = useState([]);
  const [lockerStartDate, setLockerStartDate] = useState(moment().format('YYYY.MM.DD'));
  const [lockerEndDate, setLockerEndDate] = useState(moment().format('YYYY.MM.DD'));
  const [selectedLocker, setSelectedLocker] = useState({ id: 0, name: t('memberRegistration.select') });

  const [totalLockerPrice, setTotalLockerPrice] = useState(0);
  // value //

  // 링크페이 사용여부 확인하기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('store/check/linkpay', 'GET');
        if (responseData.status === 200) setIsUseLinkoPay(responseData.data[0]);
      }
    )();
  }, [])

  // 카테고리 및 회원권 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('membership/', 'GET');

        if (responseData.status === 200) {
          setMemberships(responseData.data.memberShips);
          setCategories(responseData.data.categories);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history])

  // 결제수단 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('payment_option/', 'GET');

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [])

  // 포인트 정보 불러오기 //
  useEffect(() => {
    if (isFindUserId) {
      let linkCoachId = userId;

      if (linkCoachId === '') linkCoachId = 'None-' + phone;

      let requestData = {
        storeId: window.sessionStorage.getItem('StoreId'),
        userId: linkCoachId
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('point/available/find_member', 'POST', requestData);

          if (responseData.status === 200) {
            setTotalPoint(responseData.data.totalPoint);
          }
        }
      )();
    }
  }, [isFindUserId, userId, phone])

  // 사용가능 락커 정보 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('locker/available', 'POST');

        if (responseData.status === 200) {
          setAvailableLockers(responseData.data);
        }
      }
    )();
  }, [])

  // 카테고리에 따라 회원권 정렬하기 //
  useEffect(() => {
    if (selectedCategory === undefined || selectedCategory.id === 0) {
      setCategorizedMemberships([]);
      setSelectedMembership({ id: 0, name: t('memberRegistration.select') });
      return;
    }

    let newCategorizedMemberships = [];

    for (let i = 0; i < memberships.length; i++) {
      if (selectedCategory.id === memberships[i].categoryId) {
        newCategorizedMemberships.push(memberships[i]);
      }
    }

    setSelectedMembership({ id: 0, name: t('memberRegistration.select') });
    setCategorizedMemberships(newCategorizedMemberships);
  }, [selectedCategory, memberships])

  // 미수금 산정하기 //
  useEffect(() => {
    if (selectedMembership.id === 0) {
      setNotReceived(0);
      return;
    }

    let totalPrice = 0;

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== '') totalPrice += parseInt(selectedPaymentOptions[i].price.toString().replaceAll(',', ''));
    }

    if (discount !== '') totalPrice += parseInt(discount.toString().replaceAll(',', ''));

    setNotReceived(Math.max(selectedMembership.price - totalPrice, 0));
  }, [selectedMembership, selectedPaymentOptions, discount]);

  // 락커 가격 산정하기 //
  useEffect(() => {
    let totalPrice = 0;

    for (let i = 0; i < selectedLockerPaymentOptions.length; i++) {
      if (selectedLockerPaymentOptions[i].price !== '') totalPrice += parseInt(selectedLockerPaymentOptions[i].price.toString().replaceAll(',', ''));
    }

    setTotalLockerPrice(totalPrice);
  }, [isUseLocker, selectedLockerPaymentOptions]);

  // 회원권 종료일 자동 세팅 //
  useEffect(() => {
    if (startDate === '' || selectedMembership.id === 0) return;

    let validity = selectedMembership.validity;
    let division = selectedMembership.validityUnit;

    setEndDate(moment(startDate, 'YYYY.MM.DD').add(validity, division).subtract(1, 'days').format('YYYY.MM.DD'));
  }, [startDate, selectedMembership]);

  // 회원권 총 횟수 세팅 //
  useEffect(() => {
    if (selectedMembership.id === 0) setTotalMax(-1);
    else setTotalMax(selectedMembership.totalMax);
  }, [selectedMembership])

  // 회원권 변경 시 결제수단 초기화 및 가격 자동 설정 //
  useEffect(() => {
    const price = selectedMembership.id === 0 ? 0 : (selectedMembership.price || 0);
    setSelectedPaymentOptions([{ id: 0, name: '현금', price: price }]);
  }, [selectedMembership])

  // 전화번호 없음 클릭시 //
  function onClickNoPhone() {
    if (noHavePhone) {
      setNoHavePhone(false);
      setIsFindUserId(false);
    }
    else {
      setNoHavePhone(true);
      setIsFindUserId(true);
    }
  }

  // 전화번호 확인 버튼 클릭시 //
  function onClickLinkCoachIdCheck() {
    if (phone === '' || phone.length < 6) {
      setPhoneErrorMsg(t('memberRegistration.alertPhoneRequired'));
      return;
    }

    let data = {
      phone: phone,
      userId: '',
      profile: ''
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfCoach('userInfo/detail/invalid/user', 'POST', data);

        if (responseData.status === 200) {
          setProfile(responseData.data[0].profile);
          setUserId(responseData.data[0].userId);
          setName(responseData.data[0].name);

          let genderNum = responseData.data[0].genderNum.replaceAll('*', '');

          if (genderNum === '1' || genderNum === '3') setGender('male');
          else setGender('female');

          if (genderNum === '1' || genderNum === '2' || genderNum === '5' || genderNum === '6') setBirth('19' + responseData.data[0].birth);
          else setBirth('20' + responseData.data[0].birth);

          if (responseData.data[0].countryCode && countryCodeSelectBoxRef.current) {
            countryCodeSelectBoxRef.current.setByCode(responseData.data[0].countryCode);
          }

          setIsFindUserId(true);
        }
        else if (responseData.status === 201) {
          alert(t('memberRegistration.alertMemberMismatch'));
          setIsFindUserId(true);
        }
        else if (responseData.status === 204) {
          alert(t('memberRegistration.alertMemberNotFound'));
          setIsFindUserId(true);
        }
        else if (responseData.status === 401) {
          alert(t('memberRegistration.alertLoginRequired'));
          history.push('/');
        }
      }
    )();
  }

  // 최대 수강 횟수 변경시 //
  function onChangeTotalMax(value) {
    const onlyNumber = value.replace(/[^0-9]/g, ''); // 숫자 이외 제거
    setTotalMax(Number(onlyNumber));
  }

  // 결제 옵션 추가 버튼 클릭시 //
  function onClickAdditionOption() {
    setIsClickedAddPaymentOption(true);
  }

  // 결제수단 모달 내에서 결제수단 저장하기 클릭시 //
  function onClickSavePaymentOption(optionName) {
    if (optionName === '') {
      alert(t('memberRegistration.alertPaymentNameRequired'));
      return;
    }

    if (isLoading) {
      alert(t('memberRegistration.alertSavingInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      optionName: optionName
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/save', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 결제 수단 삭제버튼 클릭시 //
  function onClickDeleteOption(paymentOptionId) {
    if (isLoading) {
      alert(t('memberRegistration.alertDeletingInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      paymentOptionId: paymentOptionId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/delete', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }


  // 회원권 결제 수단 변경시 //
  function onChangeSelectedPaymentOptions(data, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].id = data.id;
    newSelectedPaymentOptions[index].name = data.name;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 금액 변경시 //
  function onChangePaymentOptionPrice(value, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();
    let finalValue = value.replaceAll(',', '');

    if (finalValue !== '') newSelectedPaymentOptions[index].price = parseInt(finalValue).toLocaleString('ko-KR');
    else newSelectedPaymentOptions[index].price = finalValue;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 추가 버튼 클릭시 //
  function onClickAddPaymentOptions() {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    const membershipPrice = selectedMembership.id === 0 ? 0 : (selectedMembership.price || 0);
    const alreadyEntered = newSelectedPaymentOptions.reduce((sum, opt) => {
      const p = parseInt(opt.price.toString().replaceAll(',', '')) || 0;
      return sum + p;
    }, 0);
    const remaining = Math.max(membershipPrice - alreadyEntered, 0);

    newSelectedPaymentOptions.push({ id: 0, name: '현금', price: remaining });

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 제거 버튼 클릭시 //
  function onClickDeletePaymentOptions(index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.splice(index, 1);

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 할인 금액 변경시 //
  function onChangeDiscount(value) {
    let finalValue = value.replaceAll(',', '');

    if (finalValue !== '') setDiscount(parseInt(finalValue).toLocaleString('ko-KR'));
    else setDiscount(finalValue);
  }

  // 락커 결제 수단 변경시 //
  function onChangeSelectedLockerPaymentOptions(data, index) {
    let newSelectedLockerPaymentOptions = selectedLockerPaymentOptions.slice();

    newSelectedLockerPaymentOptions[index].id = data.id;
    newSelectedLockerPaymentOptions[index].name = data.name;

    setSelectedLockerPaymentOptions(newSelectedLockerPaymentOptions);
  }

  // 락커 결제 수단 추가 버튼 클릭시 //
  function onClickAddLockerPaymentOptions() {
    let newSelectedLockerPaymentOptions = selectedLockerPaymentOptions.slice();

    newSelectedLockerPaymentOptions.push({ id: 0, name: '현금', price: 0 });

    setSelectedLockerPaymentOptions(newSelectedLockerPaymentOptions);
  }

  // 락커 결제 수단 제거 버튼 클릭시 //
  function onClickDeleteLockerPaymentOptions(index) {
    let newSelectedLockerPaymentOptions = selectedLockerPaymentOptions.slice();

    newSelectedLockerPaymentOptions.splice(index, 1);

    setSelectedLockerPaymentOptions(newSelectedLockerPaymentOptions);
  }

  // 락커 결제 금액 변경시 //
  function onChangeLockerPaymentOptionPrice(value, index) {
    let newSelectedLockerPaymentOptions = selectedLockerPaymentOptions.slice();

    let finalValue = value.replaceAll(',', '');

    if (finalValue !== '') newSelectedLockerPaymentOptions[index].price = parseInt(finalValue).toLocaleString('ko-KR');
    else newSelectedLockerPaymentOptions[index].price = finalValue;

    setSelectedLockerPaymentOptions(newSelectedLockerPaymentOptions);
  }

  // 회원등록 버튼 클릭시 //
  function onClickRegistMemberButton() {
    if (!isFindUserId) return;

    if (!checkAvailableRegistration()) return;

    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    let finalLockerCashPrice = 0;
    let finalLockerCardPrice = 0;
    let finalLockerPoint = 0;

    let finalSelectedPaymentOptions = [];
    let finalSelectedLockerPaymentOptions = [];

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== '' && selectedPaymentOptions[i].price !== 0)
        finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
    }

    for (let i = 0; i < selectedLockerPaymentOptions.length; i++) {
      if (selectedLockerPaymentOptions[i].price !== '' && selectedLockerPaymentOptions[i].price !== 0)
        finalSelectedLockerPaymentOptions.push(selectedLockerPaymentOptions[i]);
    }

    for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
      const optPrice = parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += optPrice;
      else if (finalSelectedPaymentOptions[i].name === '카드' || finalSelectedPaymentOptions[i].name === '링코페이') finalCardPrice += optPrice;
      else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += optPrice;
    }

    for (let i = 0; i < finalSelectedLockerPaymentOptions.length; i++) {
      const lockerOptPrice = parseInt(finalSelectedLockerPaymentOptions[i].price.toString().replaceAll(',', ''));
      if (finalSelectedLockerPaymentOptions[i].name === '현금') finalLockerCashPrice += lockerOptPrice;
      else if (finalSelectedLockerPaymentOptions[i].name === '카드' || finalSelectedLockerPaymentOptions[i].name === '링코페이') finalLockerCardPrice += lockerOptPrice;
      else if (finalSelectedLockerPaymentOptions[i].name === '포인트') finalLockerPoint += lockerOptPrice;
    }

    if ((finalPoint + finalLockerPoint) > 0 && parseInt((finalPoint + finalLockerPoint).toString().replaceAll(',', '')) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
      alert(t('memberRegistration.alertPointExceeded'));
      return;
    }

    if (isInProgress) {
      alert(t('memberRegistration.alertSaving'));
      return;
    }

    setIsInProgress(true);

    const resolveId = (name) => (paymentOptions.find(p => p.name === name) || { id: 0 }).id;

    let data = {
      registrationType: 'NEW_MEMBER',
      storeId: parseInt(window.sessionStorage.getItem('StoreId')),
      memberInfo: {
        name: name,
        phone: phone,
        noHavePhone: noHavePhone,
        birthDay: birth,
        gender: gender,
        profile: profile === undefined ? '' : profile,
        memberDetail: memberDetail,
      },
      membershipId: selectedMembership.id,
      startDate: startDate.replaceAll('.', '-') + 'T00:00:00',
      endDate: endDate.replaceAll('.', '-') + 'T23:59:59',
      totalMax: totalMax,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice,
      discountPrice: 0,
      notReceivedPrice: notReceived,
      point: finalPoint,
      approvalDate: approvalDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'),
      membershipPaymentOptions: finalSelectedPaymentOptions.map(opt => ({ id: resolveId(opt.name), name: opt.name, price: parseInt(opt.price.toString().replaceAll(',', '')) })),
      locker: isUseLocker ? {
        addLocker: true,
        lockerId: selectedLocker.id,
        lockerName: selectedLocker.name,
        lockerCardPrice: finalLockerCardPrice,
        lockerCashPrice: finalLockerCashPrice,
        lockerDiscountPrice: 0,
        lockerPoint: finalLockerPoint,
        lockerStartDate: lockerStartDate.replaceAll('.', '-') + 'T00:00:00',
        lockerEndDate: lockerEndDate.replaceAll('.', '-') + 'T23:59:59',
        lockerPaymentOptions: finalSelectedLockerPaymentOptions.map(opt => ({ id: resolveId(opt.name), name: opt.name, price: parseInt(opt.price.toString().replaceAll(',', '')) }))
      } : null
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/enroll', 'POST', data);

        if (responseData.status === 200) {
          setRegisteredMemberId(responseData.data?.id);
          setIsViewCompleteModal(true);
          setIsInProgress(false);
        }
        else if (responseData.status === 206) {
          alert(t('memberRegistration.alertSubscriptionLinkoPayOnly'));
          setIsInProgress(false);
        }
        else if (responseData.status === 401) {
          alert(t('memberRegistration.alertLoginFirst'));
          history.push('/');
          setIsInProgress(false);
        }
        else {
          alert(t('memberRegistration.alertRegistrationFailed'));
          setIsInProgress(false);
        }
      }
    )();
  }

  // 등록을 위해 모든 데이터가 채워졌는지 여부 확인 //
  function checkAvailableRegistration() {
    if (startDate === '') {
      alert(t('memberRegistration.alertSetStartDate'));
      return false;
    }

    if (endDate === '') {
      alert(t('memberRegistration.alertSetEndDate'));
      return false;
    }

    if (approvalDate === '') {
      alert(t('memberRegistration.alertSetPaymentDate'));
      return false;
    }

    if (selectedMembership.id === 0) {
      alert(t('memberRegistration.alertSelectMembership'));
      return false;
    }

    if (name === '') {
      alert(t('memberRegistration.alertEnterName'));
      return false;
    }

    if (birth === '' || birth.length !== 8) {
      alert(t('memberRegistration.alertEnterBirth'));
      return false;
    }

    if (!noHavePhone && (phone === '' || phone.length < 8)) {
      alert(t('memberRegistration.alertEnterPhone'));
      return false;
    }

    if (!isFindUserId) {
      alert(t('memberRegistration.alertConfirmPhone'));
      return false;
    }

    let checkStartDate = moment(startDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'));
    let checkEndDate = moment(endDate.replaceAll('.', '-') + 'T23:59:59');

    if (checkEndDate.isBefore(checkStartDate)) {
      alert(t('memberRegistration.alertInvalidEndDate'));
      return false;
    }

    if (isUseLocker) {
      if (selectedLocker.id === 0) {
        alert(t('memberRegistration.alertSelectLocker'));
        return false;
      }

      let checkLockerStartDate = moment(lockerStartDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'));
      let checkLockerEndDate = moment(lockerEndDate.replaceAll('.', '-') + 'T23:59:59');

      if (checkLockerEndDate.isBefore(checkLockerStartDate)) {
        alert(t('memberRegistration.alertInvalidLockerEndDate'));
        return false;
      }
    }

    return true;
  }

  // 회원 등록 모달에서 현장결제 클릭시 //
  function onClickOnSitePayment() {

    if (!checkAvailableRegistration()) {
      setIsViewPaymentModal(false);
      return;
    }

    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    let finalLockerCashPrice = 0;
    let finalLockerCardPrice = 0;
    let finalLockerPoint = 0;

    let finalSelectedPaymentOptions = [];
    let finalSelectedLockerPaymentOptions = [];

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== ''
        && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
    }

    for (let i = 0; i < selectedLockerPaymentOptions.length; i++) {
      if (selectedLockerPaymentOptions[i].price !== ''
        && selectedLockerPaymentOptions[i].price !== 0) finalSelectedLockerPaymentOptions.push(selectedLockerPaymentOptions[i]);
    }

    for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
      const optPrice = parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += optPrice;
      else if (finalSelectedPaymentOptions[i].name === '카드' || finalSelectedPaymentOptions[i].name === '링코페이') finalCardPrice += optPrice;
      else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += optPrice;
    }

    for (let i = 0; i < finalSelectedLockerPaymentOptions.length; i++) {
      const lockerOptPrice = parseInt(finalSelectedLockerPaymentOptions[i].price.toString().replaceAll(',', ''));
      if (finalSelectedLockerPaymentOptions[i].name === '현금') finalLockerCashPrice += lockerOptPrice;
      else if (finalSelectedLockerPaymentOptions[i].name === '카드' || finalSelectedLockerPaymentOptions[i].name === '링코페이') finalLockerCardPrice += lockerOptPrice;
      else if (finalSelectedLockerPaymentOptions[i].name === '포인트') finalLockerPoint += lockerOptPrice;
    }

    if ((finalPoint + finalLockerPoint) > 0 && parseInt((finalPoint + finalLockerPoint).toString().replaceAll(',', '')) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
      alert(t('memberRegistration.alertPointExceeded'));
      return;
    }
    else if (isInProgress) {
      alert(t('memberRegistration.alertSaving'));
      return;
    }

    setIsInProgress(true);

    const resolveId = (name) => (paymentOptions.find(p => p.name === name) || { id: 0 }).id;

    let data = {
      registrationType: 'NEW_MEMBER',
      storeId: parseInt(window.sessionStorage.getItem('StoreId')),
      memberInfo: {
        name: name,
        phone: phone,
        noHavePhone: noHavePhone,
        birthDay: birth,
        gender: gender,
        profile: profile === undefined ? '' : profile,
        memberDetail: memberDetail,
      },
      membershipId: selectedMembership.id,
      startDate: startDate.replaceAll('.', '-') + 'T00:00:00',
      endDate: endDate.replaceAll('.', '-') + 'T23:59:59',
      totalMax: totalMax,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice,
      discountPrice: 0,
      notReceivedPrice: notReceived,
      point: finalPoint,
      approvalDate: approvalDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'),
      membershipPaymentOptions: finalSelectedPaymentOptions.map(opt => ({ id: resolveId(opt.name), name: opt.name, price: parseInt(opt.price.toString().replaceAll(',', '')) })),
      locker: isUseLocker ? {
        addLocker: true,
        lockerId: selectedLocker.id,
        lockerName: selectedLocker.name,
        lockerCardPrice: finalLockerCardPrice,
        lockerCashPrice: finalLockerCashPrice,
        lockerDiscountPrice: 0,
        lockerPoint: finalLockerPoint,
        lockerStartDate: lockerStartDate.replaceAll('.', '-') + 'T00:00:00',
        lockerEndDate: lockerEndDate.replaceAll('.', '-') + 'T23:59:59',
        lockerPaymentOptions: finalSelectedLockerPaymentOptions.map(opt => ({ id: resolveId(opt.name), name: opt.name, price: parseInt(opt.price.toString().replaceAll(',', '')) }))
      } : null
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/enroll', 'POST', data);

        if (responseData.status === 200) {
          alert(t('memberRegistration.alertRegistrationComplete'));
          history.push('/main');
          setIsInProgress(false);
        }
        else if (responseData.status === 401) {
          alert(t('memberRegistration.alertLoginFirst'));
          history.push('/');
          setIsInProgress(false);
        }
        else {
          alert(t('memberRegistration.alertRegistrationFailed'));
          setIsInProgress(false);
        }
      }
    )();
  }

  // 회원 등록 모달에서 링코페이 클릭시 //
  function onClickLinkoPay() {
    if (!checkAvailableRegistration()) {
      setIsViewPaymentModal(false);
      return;
    }

    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    let finalLockerCashPrice = 0;
    let finalLockerCardPrice = 0;
    let finalLockerPoint = 0;

    let finalSelectedPaymentOptions = [];
    let finalSelectedLockerPaymentOptions = [];

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== ''
        && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
    }

    for (let i = 0; i < selectedLockerPaymentOptions.length; i++) {
      if (selectedLockerPaymentOptions[i].price !== ''
        && selectedLockerPaymentOptions[i].price !== 0) finalSelectedLockerPaymentOptions.push(selectedLockerPaymentOptions[i]);
    }

    for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
      const optPrice = parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += optPrice;
      else if (finalSelectedPaymentOptions[i].name === '카드' || finalSelectedPaymentOptions[i].name === '링코페이') finalCardPrice += optPrice;
      else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += optPrice;
    }

    for (let i = 0; i < finalSelectedLockerPaymentOptions.length; i++) {
      const lockerOptPrice = parseInt(finalSelectedLockerPaymentOptions[i].price.toString().replaceAll(',', ''));
      if (finalSelectedLockerPaymentOptions[i].name === '현금') finalLockerCashPrice += lockerOptPrice;
      else if (finalSelectedLockerPaymentOptions[i].name === '카드' || finalSelectedLockerPaymentOptions[i].name === '링코페이') finalLockerCardPrice += lockerOptPrice;
      else if (finalSelectedLockerPaymentOptions[i].name === '포인트') finalLockerPoint += lockerOptPrice;
    }

    if ((finalPoint + finalLockerPoint) > 0 && parseInt((finalPoint + finalLockerPoint).toString().replaceAll(',', '')) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
      alert(t('memberRegistration.alertPointExceeded'));
      return;
    }
    else if (isInProgress) {
      alert(t('memberRegistration.alertSaving'));
      return;
    }

    setIsInProgress(true);

    const resolveId = (name) => (paymentOptions.find(p => p.name === name) || { id: 0 }).id;

    let data = {
      registrationType: 'NEW_MEMBER',
      storeId: parseInt(window.sessionStorage.getItem('StoreId')),
      memberInfo: {
        name: name,
        phone: phone,
        noHavePhone: noHavePhone,
        birthDay: birth,
        gender: gender,
        profile: profile === undefined ? '' : profile,
        memberDetail: memberDetail,
      },
      membershipId: selectedMembership.id,
      startDate: startDate.replaceAll('.', '-') + 'T00:00:00',
      endDate: endDate.replaceAll('.', '-') + 'T23:59:59',
      totalMax: totalMax,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice,
      discountPrice: 0,
      notReceivedPrice: notReceived,
      point: finalPoint,
      approvalDate: approvalDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'),
      membershipPaymentOptions: finalSelectedPaymentOptions.map(opt => ({ id: resolveId(opt.name), name: opt.name, price: parseInt(opt.price.toString().replaceAll(',', '')) })),
      locker: isUseLocker ? {
        addLocker: true,
        lockerId: selectedLocker.id,
        lockerName: selectedLocker.name,
        lockerCardPrice: finalLockerCardPrice,
        lockerCashPrice: finalLockerCashPrice,
        lockerDiscountPrice: 0,
        lockerPoint: finalLockerPoint,
        lockerStartDate: lockerStartDate.replaceAll('.', '-') + 'T00:00:00',
        lockerEndDate: lockerEndDate.replaceAll('.', '-') + 'T23:59:59',
        lockerPaymentOptions: finalSelectedLockerPaymentOptions.map(opt => ({ id: resolveId(opt.name), name: opt.name, price: parseInt(opt.price.toString().replaceAll(',', '')) }))
      } : null
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/enroll', 'POST', data);

        if (responseData.status === 200) {
          alert(t('memberRegistration.alertRegistrationComplete'));
          history.push('/main');
          setIsInProgress(false);
        }
        else if (responseData.status === 401) {
          alert(t('memberRegistration.alertLoginFirst'));
          history.push('/');
          setIsInProgress(false);
        }
        else {
          alert(t('memberRegistration.alertRegistrationFailed'));
          setIsInProgress(false);
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      {isViewCompleteModal && <RegistrationCompleteModal
        goFn={() => history.push('/member/valid/detail/' + registeredMemberId)}
        closeFn={() => { setIsViewCompleteModal(false); history.push('/main'); }} />}
      {isClickedAddPaymentOption && <AddPaymentOptionModal onClickSave={onClickSavePaymentOption} onClickExit={() => setIsClickedAddPaymentOption(false)} />}
      {
        isViewPaymentModal && isUseLinkoPay &&
        <LinkoPayPaymentModal
          onClickOnSitePayment={onClickOnSitePayment}
          onClickLinkoPay={onClickLinkoPay}
          onClickExit={() => setIsViewPaymentModal(false)} />
      }
      {
        isViewPaymentModal && !isUseLinkoPay &&
        <OnSitePaymentModal
          selectedMembership={selectedMembership}
          selectedPaymentOptions={selectedPaymentOptions}
          selectedLockerPaymentOptions={selectedLockerPaymentOptions}
          onClickOnSitePayment={onClickOnSitePayment}
          onClickExit={() => setIsViewPaymentModal(false)} />
      }
      <TopLineWrapper>
        <TitleWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('memberRegistration.title')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('memberRegistration.desc')}</Text>
        </TitleWrapper>
        <RegistrationButton isView={isFindUserId} onClick={onClickRegistMemberButton}>
          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor={isFindUserId ? 'pointer' : 'default'}>{t('memberRegistration.registerBtn')}</Text>
        </RegistrationButton>
      </TopLineWrapper>
      <TotalMemberInfoBoxWrapper>
        <MemberInfoBox>
          <MemberInfoWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('memberRegistration.basicInfo')}</Text>
            <DivisionLine margin={15} />
            <LayerWrapper marginTop={0} gap={10}>
              <InputWrapper>
                <PhoneTitleWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.phone')}</Text>
                  <NoHavePhoneWrapper onClick={onClickNoPhone}>
                    <NoHavePhoneCheckBox isClicked={noHavePhone} />
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>{t('memberRegistration.noPhone')}</Text>
                  </NoHavePhoneWrapper>
                </PhoneTitleWrapper>
                <PhoneInputWrapper>
                  <CountryCodeSelectBox ref={countryCodeSelectBoxRef} selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} />
                  <CustomInput
                    value={phone}
                    setValue={setPhone}
                    placeholder={t('memberRegistration.phonePlaceholder')}
                    disabled={noHavePhone}
                    onlyNumber={true}
                    flexShrink={true}
                    onFocus={() => setPhoneErrorMsg('')}/>
                  <FindIdButton onClick={onClickLinkCoachIdCheck}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('memberRegistration.confirm')}</Text>
                  </FindIdButton>
                </PhoneInputWrapper>
                <PhoneErrorTextWrapper>
                  {
                    phoneErrorMsg &&
                    <PhoneErrorText>{phoneErrorMsg}</PhoneErrorText>
                  }
                </PhoneErrorTextWrapper>
              </InputWrapper>
            </LayerWrapper>
            <LayerWrapper marginTop={10} gap={10}>
              <InputWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.name')}</Text>
                <CustomInput
                  value={name}
                  setValue={setName}
                  placeholder={t('memberRegistration.namePlaceholder')}
                  disabled={false}
                  width={120} />
              </InputWrapper>
              <InputWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.gender')}</Text>
                <GenderSelectBox gender={gender} setGender={setGender} />
              </InputWrapper>
              <InputWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.birthDate')}</Text>
                <CustomInput
                  value={birth}
                  setValue={setBirth}
                  placeholder='YYYYMMDD'
                  disabled={false}
                  width={78}
                  onlyNumber={true} />
              </InputWrapper>
            </LayerWrapper>
            <LayerWrapper marginTop={15} gap={10}>
              <InputWrapper style={{ flex: 'none', width: 'auto' }}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.profilePhoto')}</Text>
                <ProfileInput
                  imgBase64={profile}
                  setImgBase64={setProfile} />
              </InputWrapper>
              <InputWrapper style={{ marginRight: '17px' }}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.linkoId')}</Text>
                <LinkoIdInputView>
                  <LinkoIdInputViewTextWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={userId === '' ? theme.line : theme.text} cursor='default'>{userId === '' ? t('memberRegistration.checkSignup') : userId}</Text>
                  </LinkoIdInputViewTextWrapper>
                </LinkoIdInputView>
              </InputWrapper>
            </LayerWrapper>
            <LayerWrapper marginTop={30}>
              <InputWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.classNotes')}</Text>
                <TextAreaInput
                  value={memberDetail}
                  setValue={setMemberDetail}
                  placeholder={t('memberRegistration.classNotesPlaceholder')}
                  disabled={false}
                  width={367} />
              </InputWrapper>
            </LayerWrapper>
          </MemberInfoWrapper>
        </MemberInfoBox>
        <MembershipAndLockerInfoWraper isView={isFindUserId}>
          {
            isFindUserId &&
            <MembershipBox>
              <MembershipBoxInnerWrapper>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('memberRegistration.membershipInfo')}</Text>
                <DivisionLine margin={10} />
                <LayerWrapper
                  marginTop={0}
                  gap={20}
                  style={{ zIndex: selectedPaymentOptions.length + 3 }}>
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.category')}</Text>
                    <OptionSelectBox
                      value={selectedCategory}
                      setValue={setSelectedCategory}
                      options={categories}
                      disabled={categories.length === 0}
                      width={266} />
                  </InputWrapper>
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.membership')}</Text>
                    <OptionSelectBox
                      value={selectedMembership}
                      setValue={setSelectedMembership}
                      options={categorizedMemberships}
                      disabled={categorizedMemberships.length === 0}
                      width={266} />
                  </InputWrapper>
                  </LayerWrapper>
                  <LayerWrapper
                    marginTop={10}
                    gap={20}
                    style={{ zIndex: selectedPaymentOptions.length + 2 }}>
                    <CalendarWrapper>
                      <InputWrapper>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.startDate')}</Text>
                        <CalenderInput
                          value={startDate}
                          setValue={setStartDate}
                          disabled={false}
                          placeholder={t('memberRegistration.startDate')} />
                      </InputWrapper>
                      <InputWrapper>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.endDate')}</Text>
                        <CalenderInput
                          value={endDate}
                          setValue={setEndDate}
                          disabled={false}
                          placeholder={t('memberRegistration.endDate')} />
                      </InputWrapper>
                    </CalendarWrapper>
                    <InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.maxSessions')}</Text>
                      <UnitInputWrapper>
                        <CustomInput
                          value={totalMax === -1 ? t('memberRegistration.noLimit') : totalMax}
                          setValue={onChangeTotalMax}
                          placeholder='0'
                          disabled={totalMax === -1}
                          width={231} />
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.sessionUnit')}</Text>
                      </UnitInputWrapper>
                    </InputWrapper>
                  </LayerWrapper>
                </MembershipBoxInnerWrapper>
              <PaymentInfoWrapper marginTop={20}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.paymentInfo')}</Text>
                <DivisionLine margin={10} />
                <LayerWrapper
                  marginTop={0}
                  gap={10}
                  style={{ zIndex: selectedPaymentOptions.length + 1 }}>
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.paymentDate')}</Text>
                    <CalenderInput
                      value={approvalDate}
                      setValue={setApprovalDate}
                      disabled={false}
                      placeholder={t('memberRegistration.paymentDate')}
                      width={266} />
                  </InputWrapper>
                  <RowDivisionLine />
                  <InputWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.membershipPrice')}</Text>
                    <UnitInputWrapper>
                      {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                      <CustomInput
                        value={selectedMembership.id === 0 ? '0' : selectedMembership.price.toLocaleString('ko-KR')}
                        placeholder='0'
                        disabled={true}
                        textAlign={isEng ? 'left' : 'right'}
                        width={231} />
                      {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                    </UnitInputWrapper>
                  </InputWrapper>
                </LayerWrapper>
                {
                  selectedPaymentOptions.map((data, index) => (
                    <LayerWrapper
                      key={'SelectedPaymentOptions-' + index}
                      marginTop={10}
                      gap={10}
                      style={{ zIndex: selectedPaymentOptions.length - index }}>
                      <InputWrapper>
                        <PaymentOptionTitleWrapper>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.paymentMethod') + (index === 0 ? '' : index + 1)}</Text>
                          {
                            index !== 0 &&
                            <DeleteButton onClick={() => onClickDeletePaymentOptions(index)}>
                              <DeleteIcon src={WhiteTrashIcon} />
                            </DeleteButton>
                          }
                        </PaymentOptionTitleWrapper>
                        <PaymentOptionSettingSelectBox
                          index={index}
                          value={data}
                          setValue={onChangeSelectedPaymentOptions}
                          options={paymentOptions}
                          disabled={paymentOptions.length === 0}
                          width={266}
                          includeLinkoPayOption={isUseLinkoPay}
                          onClickAdditionOption={onClickAdditionOption}
                          onClickDeleteOption={onClickDeleteOption} />
                      </InputWrapper>
                      <RowDivisionLine />
                      <InputWrapper>
                        <PaymentOptionTitleWrapper>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.receivedPrice')}</Text>
                          {data.id === 0 && data.name === '포인트' && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subKey} cursor='default'>{totalPoint.toLocaleString('ko-KR') + t('memberRegistration.pointAvailable')}</Text>}
                        </PaymentOptionTitleWrapper>
                        <UnitInputWrapper>
                          {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                          <PaymentOptionCustomInput
                            index={index}
                            value={data.price.toLocaleString('ko-KR')}
                            setValue={onChangePaymentOptionPrice}
                            placeholder='0'
                            disabled={false}
                            textAlign={isEng ? 'left' : 'right'}
                            width={231} />
                          {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                        </UnitInputWrapper>
                      </InputWrapper>
                    </LayerWrapper>
                  ))
                }
              </PaymentInfoWrapper>
              <AddPaymentOptionButton onClick={onClickAddPaymentOptions}>{t('memberRegistration.addPaymentMethod')}</AddPaymentOptionButton>
              <LayerWrapper marginTop={20} gap={10}>
                <InputWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.discountAmount')}</Text>
                  <UnitInputWrapper>
                    {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subKey} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                    <DiscountAmountInput
                      value={discount.toLocaleString('ko-KR')}
                      setValue={onChangeDiscount}
                      placeholder='0'
                      width={231}
                      textAlign={isEng ? 'left' : 'right'} />
                    {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subKey} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                  </UnitInputWrapper>
                </InputWrapper>
                <RowDivisionLine />
                <InputWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.unpaidAmount')}</Text>
                  <UnitInputWrapper>
                    {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.pointRed} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                    <NotReceivedInputView width={231} style={{ justifyContent: isEng ? 'flex-start' : 'flex-end' }}>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.pointRed} cursor='default'>{notReceived.toLocaleString('ko-KR')}</Text>
                    </NotReceivedInputView>
                    {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.pointRed} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                  </UnitInputWrapper>
                </InputWrapper>
              </LayerWrapper>
            </MembershipBox>
          }

          <AddLockerButton isView={!isUseLocker} onClick={() => setIsUseLocker(true)}>
            <LockerIcon src={ClickLockerImagePath} />
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.white} cursor='pointer'>{t('memberRegistration.addLocker')}</Text>
          </AddLockerButton>

          <LockerInfoBox isView={isUseLocker}>
            {
              isUseLocker &&
              <LockerInfoWrapper>
                <MembershipBoxInnerWrapper>
                  <LockerColumnWrapper>
                    <ColumnView onClick={() => setIsUseLocker(false)}>
                      <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('memberRegistration.lockerInfo')}</Text>
                      {/* <LockerIcon src={ClickLockerImagePath} />
                    <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.white} cursor='pointer'>{t('memberRegistration.removeLockerInfo')}</Text> */}
                      <StyledExitPlus />
                    </ColumnView>
                  </LockerColumnWrapper>
                  <DivisionLine margin={10} />
                  <LayerWrapper
                    marginTop={0}
                    gap={20}
                    style={{ zIndex: selectedLockerPaymentOptions.length + 2 }}>
                    <InputWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.selectLocker')}</Text>
                      <OptionSelectBox
                        value={selectedLocker}
                        setValue={setSelectedLocker}
                        options={availableLockers}
                        disabled={availableLockers.length === 0}
                        width={553} />
                    </InputWrapper>
                  </LayerWrapper>
                  <LayerWrapper
                    marginTop={10}
                    gap={20}
                    style={{ marginBottom: '10px', zIndex: selectedLockerPaymentOptions.length + 1 }}>
                      <CalendarWrapper>
                        <InputWrapper>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.startDate')}</Text>
                          <CalenderInput
                            value={lockerStartDate}
                            setValue={setLockerStartDate}
                            disabled={false}
                            placeholder={t('memberRegistration.startDate')} />
                        </InputWrapper>
                        <InputWrapper>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.endDate')}</Text>
                          <CalenderInput
                            value={lockerEndDate}
                            setValue={setLockerEndDate}
                            disabled={false}
                            placeholder={t('memberRegistration.endDate')} />
                        </InputWrapper>
                      </CalendarWrapper>
                      <LockerWrapper>
                        <InputWrapper>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.lockerUseDays')}</Text>
                          <UnitInputWrapper>
                            <LockerUseDaysInputView>
                              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{moment(lockerEndDate, 'YYYY.MM.DD').diff(moment(lockerStartDate, 'YYYY.MM.DD'), 'days') + 1}</Text>
                            </LockerUseDaysInputView>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberRegistration.dayUnit')}</Text>
                          </UnitInputWrapper>
                        </InputWrapper>
                        <InputWrapper>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.lockerPrice')}</Text>
                          <UnitInputWrapper>
                            {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                            <CustomInput
                              value={totalLockerPrice.toLocaleString('ko-KR')}
                              placeholder='0'
                              disabled3={true}
                              textAlign={isEng ? 'left' : 'right'} />
                            {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                          </UnitInputWrapper>
                        </InputWrapper>
                      </LockerWrapper>
                  </LayerWrapper>
                  {
                    selectedLockerPaymentOptions.map((data, index) => (
                      <LayerWrapper
                        key={'SelectedLockerPaymentOptions-' + index}
                        marginTop={10}
                        gap={10}
                        style={{ zIndex: selectedLockerPaymentOptions.length - index }}>
                        <InputWrapper>
                          <PaymentOptionTitleWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.paymentMethod') + (index === 0 ? '' : ' ' + (index + 1))}</Text>
                            {
                              index !== 0 &&
                              <DeleteButton onClick={() => onClickDeleteLockerPaymentOptions(index)}>
                                <DeleteIcon src={WhiteTrashIcon} />
                              </DeleteButton>
                            }
                          </PaymentOptionTitleWrapper>
                          <PaymentOptionSettingSelectBox
                            index={index}
                            value={data}
                            setValue={onChangeSelectedLockerPaymentOptions}
                            options={paymentOptions}
                            disabled={paymentOptions.length === 0}
                            width={266}
                            includeLinkoPayOption={isUseLinkoPay}
                            onClickAdditionOption={onClickAdditionOption}
                            onClickDeleteOption={onClickDeleteOption} />
                        </InputWrapper>
                        <RowDivisionLine />
                        <InputWrapper>
                          <PaymentOptionTitleWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberRegistration.receivedPrice')}</Text>
                            {data.id === 0 && data.name === '포인트' && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subKey} cursor='default'>{totalPoint.toLocaleString('ko-KR') + t('memberRegistration.pointAvailable')}</Text>}
                          </PaymentOptionTitleWrapper>
                          <UnitInputWrapper>
                            {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                            <PaymentOptionCustomInput
                              index={index}
                              value={data.price.toLocaleString('ko-KR')}
                              setValue={onChangeLockerPaymentOptionPrice}
                              placeholder='0'
                              disabled={false}
                              textAlign={isEng ? 'left' : 'right'}
                              width={231} />
                            {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberRegistration.currencyUnit')}</Text>}
                          </UnitInputWrapper>
                        </InputWrapper>
                      </LayerWrapper>
                    ))
                  }
                  <AddPaymentOptionButton onClick={onClickAddLockerPaymentOptions}>{t('memberRegistration.addPaymentMethod')}</AddPaymentOptionButton>
                </MembershipBoxInnerWrapper>
              </LockerInfoWrapper>
            }
          </LockerInfoBox>
          {/* <RegistMemberWrapper>
            <RegistrationButton isView={isFindUserId} onClick={onClickRegistMemberButton}>
              <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor={isFindUserId ? 'pointer' : 'default'}>{t('memberRegistration.registerBtn')}</Text>
            </RegistrationButton>
          </RegistMemberWrapper> */}
        </MembershipAndLockerInfoWraper>
      </TotalMemberInfoBoxWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: 20px;

  width: 100%;
`;

const TopLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 1035px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const RegistrationButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 120px;
  height: 40px;

  border-radius: 11px;
  background-color: ${props => props.theme.subKey};

  opacity: ${props => props.isView ? 1 : 0};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: ${props => props.isView ? `pointer` : `default`};
  }
`;

const TotalMemberInfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 20px;

  width: 100%;
`;

const MemberInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px;
  margin-bottom: 200px;

  width: 382px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const MemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const LayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  margin-top: ${props => props.marginTop}px;

  width: 100%;

  gap: ${props => props.gap}px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const PaymentOptionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const LinkoIdInputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 5px 8px;

  width: ${props => props.width ? `${props.width}px` : '100%'};
  height: 20px;

  border-radius: 5px;
  border: 1px solid ${props => props.theme.line};
  background-color: ${props => props.theme.buttonFill};

  overflow: hidden;
`;

const LinkoIdInputViewTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;

  overflow: hidden;
`;

const PhoneErrorTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 21px;
`;

const PhoneErrorText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.pointRed};

  margin: 4px 0 0 0;
`;

const PhoneTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
`;

const NoHavePhoneWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;

  &:hover {
    cursor: pointer;
  }
`;

const NoHavePhoneCheckBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 16px;
  height: 16px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 4px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const PhoneInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  
  gap: 10px;
`;

const FindIdButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 83px;
  height: 32px;

  border-radius: 5px;
  background-color: ${props => props.theme.subKey};

  &:hover {
    cursor: pointer;
  }
`;

const MembershipAndLockerInfoWraper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: ${props => props.isClickedAddLocker ? `10px` : `20px`};

  opacity: ${props => props.isView ? 1 : 0};

  transition: all 0.3s ease-in-out;
`;

const AddLockerButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 593px;
  height: ${props => props.isView ? `40px` : `0px`};

  gap: 10px;

  border-radius: 20px;
  background-color: ${props => props.theme.primaryAlpha50};

  overflow: hidden;

  opacity: ${props => props.isView ? 1 : 0};
  pointer-events: ${props => props.isView ? `auto` : `none`};
  margin-bottom: ${props => props.isView ? `0px` : `-20px`};

  transition: all 0.3s ease-in-out;

  @media (hover: hover){
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.primary};
    }
  }
`;

const LockerIcon = styled.img`
  width: 16px;
  height: 16px;
`;

const MembershipBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px;

  width: 553px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const MembershipBoxInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;

  gap: 4px;
`;

const NotReceivedInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

	padding: 0 8px;

  width: ${props => props.width}px;
  height: 30px;

	border: 1px solid ${props => props.theme.subBackground};
	border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
`;

const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: ${props => props.marginTop}px;

  width: 100%;
`;

const DivisionLine = styled.div`
  margin-top: ${props => props.margin}px;
  margin-bottom: ${props => props.margin}px;

  width: 100%;
  height: 1px;

  background-color: ${props => props.theme.line};
`;

const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const LockerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const RowDivisionLine = styled.div`
  width: 1px;
  height: 54px;

  background-color: ${props => props.theme.line};
`;

const AddPaymentOptionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 40px;

  border-radius: 20px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.subText};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.subBackground};
    background-color: ${props => props.theme.subKey};
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: ${props => props.theme.pointRedAlpha50};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.pointRed};
  }
`;

const DeleteIcon = styled.img`
  width: 14px;
  height: 14px;
`;

const LockerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding-bottom: ${props => props.isView ? `20px` : `0px`};

  width: 593px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};

  opacity: ${props => props.isView ? 1 : 0};

  transition: all 0.3s ease-in-out;
`;

const LockerInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 553px;
`;

const LockerColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;
`;

const ColumnView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 20px;

  border-radius: 0px 10px 0px 10px;

  &:hover {
    cursor: pointer;
  }
`;

const StyledExitPlus = styled(PlusSvg)`
  width: 18px;
  height: 18px;

  flex-shrink: 0;

  transform: rotate(45deg);

  path {
    fill: ${props => props.theme.subText};
    transition: fill 0.3s ease-in-out;
  }

  @media (hover: hover) and (pointer: fine) {
    ${ColumnView}:hover & path {
      fill: ${props => props.theme.primary};
    }
  }
`;

const RegistMemberWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin: 40px 0px 30px 0px;

  width: 593px;
`;

const LockerUseDaysInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

	padding: 0 8px;

  width: ${props => props.width ? `${props.width}px` : '100%'};
  height: 30px;

	border: 1px solid ${props => props.theme.line};
	border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
